// extracted by mini-css-extract-plugin
export default {"assetOwnerInfo":"AssetOwnerInfo_assetOwnerInfo__FsfAP","info":"AssetOwnerInfo_info__7vDzz","name":"AssetOwnerInfo_name__BNofK","infoIcon":"AssetOwnerInfo_infoIcon__CysJG"};